export default __webpack_public_path__ + "static/media/right-quotes-sign.89bc4858.svg";